/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Locale } from '@app/settings/locales/locales.model';
import { Company } from '@app/settings/companies/company.model';

export class Website extends Model {
  id: number;
  company_id: number;
  company?: Company;
  name: string;
  url: string;
  active: boolean;
  locales: Array<Locale>;
  webhook_active: boolean;
  webhook_url: string;
  webhook_secret: string;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.company) {
      this.company = new Company().deserialize(input.company);
    }

    return this;
  }
}
